import { colors, ModalSmall, icons, DropdownSingle } from 'oolib';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { DEFAULT_LOCALHOST_TENANT } from '../../TENANT_CONFIGS';



const { UserSwitch } = icons;
const StyledToggleModalButton = styled.div`
  width: 4rem;
  height: 4rem;
  z-index: 1000000;
  border-radius: 50%;
  position: fixed;
  bottom: 7px;
  border: 2px solid ${({ theme }) => colors.greyColor100};
  right: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.primaryColor40};
  cursor: pointer;
`;

const LOADING_OPTIONS = Array.from({ length: 5 }, () => ({ loading: true }));

export const LocalhostTenantSwitcher = (props) => {
  //this is only for localhost

  const [mappings, setMappings] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  let localhost_tenantId =
    localStorage.getItem('localhost_tenantId') || DEFAULT_LOCALHOST_TENANT;

  useEffect(() => {
    if(!localStorage.getItem('localhost_tenantId')){
      localStorage.setItem('localhost_tenantId', DEFAULT_LOCALHOST_TENANT);
    }
    // Fetch tenant list from backend API
    axios.get('/api/tenantRegistry')
      .then(res => {
        const sortedMappings = Object.fromEntries(Object.entries(res.data.mappings || {}).sort());
        setMappings(sortedMappings);
        setIsLoading(false);
      })
      .catch(err => {
        console.error('Failed to load tenant list:', err);
        setIsLoading(false);
      });
  }, [])

  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <StyledToggleModalButton onClick={() => setShowModal((prev) => !prev)}>
        <UserSwitch color={colors.greyColor100} weight="bold" size={20} />
      </StyledToggleModalButton>
      {showModal && (
        <ModalSmall title="Switch Tenant" onClose={() => setShowModal(false)}>
          <DropdownSingle
          isSearchable
            options={isLoading
              ? LOADING_OPTIONS
              : Object.entries(mappings).map(([tenantId, url]) => ({
                  display: tenantId,
                  desc: url,
                  value: tenantId,
                }))
            }
            value={{ display: localhost_tenantId, desc: mappings[localhost_tenantId] || '', value: localhost_tenantId }}
            onChange={(k, v) => {
              localStorage.setItem('localhost_tenantId', v.value);
              window.location.reload();
            }}
          />
        </ModalSmall>
      )}
    </div>
  );
};
